import type { ArticleCardProps } from '../../../components';
import { ArticleCard } from '../../../components';

import styles from './SideRailArticles.module.scss';

export type SideRailArticleProps = ArticleCardProps & {
  sideRailArticleTitle: string;
};

export type SideRailArticlesProps = {
  articles?: Array<SideRailArticleProps> | undefined;
};

/**
 * The Side Rail Articles section component.
 * @param {Object} props - The component props.
 * @returns {ReactNode}
 */
export const SideRailArticles = ({ articles }: SideRailArticlesProps) => {
  if (!articles || !articles.length) return null;

  return (
    <section className={styles.sideRailArticles}>
      {articles.map((article, index) => (
        <div key={index} className={styles.sideRailArticles__article}>
          <h2 className="text-blog-heading-h1-mobile">
            {article.sideRailArticleTitle}
          </h2>
          <ArticleCard {...article} isSideRailArticle={true} />
        </div>
      ))}
    </section>
  );
};
